import React from 'react'

export default function OpacityBg({ onClick, children, useMaxZIndex }) {
  const bgStyle = { background: 'rgba(0, 0, 0, 0.5)' }

  return (
    <div
      className={`z-${
        useMaxZIndex ? '9999' : '10'
      } fixed right-0 top-0 left-0 bottom-0 m-0 clearfix flex items-center justify-center`}
      onClick={onClick}
      style={bgStyle}
    >
      {children}
    </div>
  )
}
